"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

function useResetScroll(ref) {
  var resetFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    top: 0,
    left: 0
  };
  react_1.useEffect(function () {
    if (ref.current !== null) {
      ref.current.scrollTo(resetFn);
    }
  });
}

exports.default = useResetScroll;